import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@mui/lab';
import { useDashboard } from '../../../contexts/DashboardContext';

export default function DashboardTimeline({ panelId, outputKey = 'timeline_data', config }) {
  const { getSlice } = useDashboard();
  const raw = getSlice(panelId, outputKey);

  const events = useMemo(() => {
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : raw?.events ?? raw?.items ?? [];
    return arr.map((item, i) => ({
      id: item.id ?? item._id ?? i,
      date: item.date ?? item.timestamp ?? '',
      title: item.title ?? item.name ?? '',
      description: item.description ?? item.detail ?? '',
    }));
  }, [raw]);

  if (!events.length) {
    return (
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 200 }}>
        <Typography color="text.secondary">No timeline data. Use chat or refresh to run a flow.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Timeline position="right">
        {events.map((event) => (
          <TimelineItem key={event.id}>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              {event.date && (
                <Typography variant="caption" color="text.secondary">
                  {event.date}
                </Typography>
              )}
              <Typography variant="subtitle2">{event.title}</Typography>
              {event.description && (
                <Typography variant="body2" color="text.secondary">
                  {event.description}
                </Typography>
              )}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
}
